import React from "react";
import { useNavigate } from "react-router-dom";

function VideoMobileDemoPage() {
  const navigate = useNavigate();

  return (
    <div className="evo-demo-page">
      <button className="evo-back-btn" onClick={() => navigate(-1)}>
        ← Retour
      </button>

      <div className="evo-glow evo-glow-1"></div>
      <div className="evo-glow evo-glow-2"></div>

      <div className="evo-phone">
        <div className="evo-feed">
          <div className="evo-video-card card-1">
            <span>🔥 Créateurs</span>
          </div>
          <div className="evo-video-card card-2">
            <span>✨ Tendances</span>
          </div>
          <div className="evo-video-card card-3">
            <span>🚀 Lives</span>
          </div>
          <div className="evo-video-card card-4">
            <span>💎 EVO</span>
          </div>
        </div>
      </div>

      <div className="evo-content">
        <h1>Un affichage vertical fluide, clair et immersif.</h1>

        <p>
          Une navigation moderne pensée pour les vidéos, les lives,
          les créateurs et l’expérience mobile EVO-LIVE.
        </p>

        
      </div>

      <style>{`
        .evo-demo-page {
          position: fixed;
          inset: 0;
          overflow: hidden;
          background:
            radial-gradient(circle at top left, rgba(0,242,255,0.25), transparent 35%),
            radial-gradient(circle at bottom right, rgba(255,0,180,0.22), transparent 35%),
            linear-gradient(135deg, #02040a, #07111f 45%, #02040a);
          color: white;
          font-family: Arial, sans-serif;
        }

        .evo-back-btn {
          position: absolute;
          top: 22px;
          left: 22px;
          z-index: 20;
          border: 1px solid #00f2ff;
          background: rgba(0,0,0,0.35);
          color: #00f2ff;
          padding: 10px 16px;
          border-radius: 14px;
          cursor: pointer;
          box-shadow: 0 0 18px rgba(0,242,255,0.35);
        }

        .evo-glow {
          position: absolute;
          width: 320px;
          height: 320px;
          border-radius: 50%;
          filter: blur(70px);
          opacity: 0.55;
          animation: floatGlow 6s ease-in-out infinite alternate;
        }

        .evo-glow-1 {
          background: #00f2ff;
          top: 10%;
          left: 8%;
        }

        .evo-glow-2 {
          background: #ff00b8;
          bottom: 8%;
          right: 8%;
          animation-delay: 1.5s;
        }

        .evo-phone {
          position: absolute;
          left: 9%;
          top: 50%;
          transform: translateY(-50%);
          width: 280px;
          height: 560px;
          border-radius: 42px;
          background: rgba(255,255,255,0.08);
          border: 1px solid rgba(255,255,255,0.18);
          box-shadow:
            0 0 45px rgba(0,242,255,0.35),
            inset 0 0 30px rgba(255,255,255,0.08);
          overflow: hidden;
          animation: phoneEnter 1s ease forwards;
        }

        .evo-phone::before {
          content: "";
          position: absolute;
          top: 12px;
          left: 50%;
          transform: translateX(-50%);
          width: 90px;
          height: 8px;
          border-radius: 20px;
          background: rgba(255,255,255,0.35);
          z-index: 5;
        }

        .evo-feed {
          position: absolute;
          inset: 0;
          animation: verticalScroll 7s ease-in-out infinite;
        }

        .evo-video-card {
          width: 100%;
          height: 560px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          font-weight: 900;
          letter-spacing: 1px;
          text-shadow: 0 0 20px rgba(0,0,0,0.8);
        }

        .card-1 {
          background: linear-gradient(160deg, #001f2e, #00f2ff);
        }

        .card-2 {
          background: linear-gradient(160deg, #240014, #ff00b8);
        }

        .card-3 {
          background: linear-gradient(160deg, #021f16, #00ff9d);
        }

        .card-4 {
          background: linear-gradient(160deg, #12002e, #7b2cff);
        }

        .evo-content {
          position: absolute;
          right: 8%;
          top: 50%;
          transform: translateY(-50%);
          max-width: 540px;
          animation: textEnter 1s ease forwards;
        }

        .evo-content h1 {
          font-size: 52px;
          line-height: 1.05;
          margin: 0 0 22px;
          background: linear-gradient(90deg, #ffffff, #00f2ff, #ff00b8);
          -webkit-background-clip: text;
          color: transparent;
          text-shadow: 0 0 35px rgba(0,242,255,0.25);
        }

        .evo-content p {
          font-size: 18px;
          line-height: 1.6;
          color: #bdefff;
          margin-bottom: 30px;
        }

        .evo-demo-btn {
          border: none;
          background: linear-gradient(90deg, #00f2ff, #0077ff, #ff00b8);
          color: white;
          padding: 15px 28px;
          border-radius: 18px;
          font-size: 17px;
          font-weight: 800;
          cursor: pointer;
          box-shadow: 0 0 28px rgba(0,242,255,0.55);
          animation: btnPulse 1.8s ease-in-out infinite;
        }

        @keyframes verticalScroll {
          0%, 18% {
            transform: translateY(0);
          }
          25%, 43% {
            transform: translateY(-560px);
          }
          50%, 68% {
            transform: translateY(-1120px);
          }
          75%, 93% {
            transform: translateY(-1680px);
          }
          100% {
            transform: translateY(0);
          }
        }

        @keyframes phoneEnter {
          from {
            opacity: 0;
            transform: translateY(-50%) translateX(-80px) scale(0.9);
          }
          to {
            opacity: 1;
            transform: translateY(-50%) translateX(0) scale(1);
          }
        }

        @keyframes textEnter {
          from {
            opacity: 0;
            transform: translateY(-40%);
          }
          to {
            opacity: 1;
            transform: translateY(-50%);
          }
        }

        @keyframes btnPulse {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 0 25px rgba(0,242,255,0.45);
          }
          50% {
            transform: scale(1.06);
            box-shadow: 0 0 45px rgba(255,0,184,0.65);
          }
        }

        @keyframes floatGlow {
          from {
            transform: translateY(0) scale(1);
          }
          to {
            transform: translateY(-35px) scale(1.15);
          }
        }

        @media (max-width: 850px) {
          .evo-phone {
            left: 50%;
            top: 44%;
            transform: translate(-50%, -50%);
            width: 220px;
            height: 430px;
          }

          .evo-video-card {
            height: 430px;
          }

          .evo-content {
            left: 24px;
            right: 24px;
            top: auto;
            bottom: 35px;
            transform: none;
            text-align: center;
          }

          .evo-content h1 {
            font-size: 30px;
          }

          .evo-content p {
            font-size: 15px;
          }

          @keyframes verticalScroll {
            0%, 18% { transform: translateY(0); }
            25%, 43% { transform: translateY(-430px); }
            50%, 68% { transform: translateY(-860px); }
            75%, 93% { transform: translateY(-1290px); }
            100% { transform: translateY(0); }
          }
        }
      `}</style>
    </div>
  );
}

export default VideoMobileDemoPage;